module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "brand",
    staticClass: "modal-mask",
    attrs: {
      "id": "brand"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('div', {
    staticClass: "modalContent"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "uppercase title center txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("standDesign.edit")))]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('label', {
    staticClass: "uppercase labelStand"
  }, [_vm._v(_vm._s(_vm.$t("standDesign.name")))])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.standDesign.name),
      expression: "standDesign.name"
    }],
    staticClass: "input inputSD",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.standDesign.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.standDesign.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "uppercase labelStand"
  }, [_vm._v(_vm._s(_vm.$t("standDesign.description")))])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.standDesign.description),
      expression: "standDesign.description"
    }],
    staticClass: "input inputSDDdes",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.standDesign.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.standDesign.description = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer boutonSaveDelete"
  }, [_c('button', {
    staticClass: "btn block pointer save uppercase",
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": function($event) {
        _vm.saveStand();
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("standDesign.save")) + "\n                                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn block pointer uppercase save",
    on: {
      "click": function($event) {
        _vm.closeModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn block pointer uppercase",
    on: {
      "click": function($event) {
        _vm.deleteStand();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("standDesign.delete")))])])], 1)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-807e5ca0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/EditStandDesign.vue
// module id = 3297
// module chunks = 0